import React, { useState } from 'react';
export function CheckInForm() {
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitted(true);
  };
  if (submitted) {
    return <div className="checkin-card bg-white border border-gray-200 rounded-lg shadow-sm p-6 sm:p-8 text-center" data-id="element-9">
        <h2 className="text-2xl font-semibold text-gray-900 mb-3" data-id="element-10">
          You're checked in!
        </h2>
        <p className="text-base text-gray-700" data-id="element-11">
          Thanks for stopping by. A member of our team will be with you shortly.
        </p>
        <button type="button" onClick={() => setSubmitted(false)} className="mt-6 text-sm font-medium text-[#C8102E] hover:underline" data-id="element-12">
          Check in another customer
        </button>
      </div>;
  }
  return <form onSubmit={handleSubmit} className="checkin-card bg-white border border-gray-200 rounded-lg shadow-sm p-6 sm:p-8" noValidate data-id="element-13">
      <div className="space-y-5" data-id="element-14">
        <div data-id="element-15">
          <label htmlFor="name" className="block text-base font-medium text-gray-900 mb-2" data-id="element-16">
            Name
          </label>
          <input id="name" name="name" type="text" required autoComplete="name" className="w-full h-12 px-4 text-base border border-gray-300 rounded-md bg-white text-gray-900 placeholder-gray-400 focus:outline-none focus:border-[#C8102E] focus:ring-2 focus:ring-[#C8102E]/20" data-id="element-17" />
        </div>

        <div data-id="element-18">
          <label htmlFor="email" className="block text-base font-medium text-gray-900 mb-2" data-id="element-19">
            Email
          </label>
          <input id="email" name="email" type="email" required autoComplete="email" className="w-full h-12 px-4 text-base border border-gray-300 rounded-md bg-white text-gray-900 placeholder-gray-400 focus:outline-none focus:border-[#C8102E] focus:ring-2 focus:ring-[#C8102E]/20" data-id="element-20" />
        </div>

        <div data-id="element-21">
          <label htmlFor="phone" className="block text-base font-medium text-gray-900 mb-2" data-id="element-22">
            Phone
          </label>
          <input id="phone" name="phone" type="tel" required autoComplete="tel" className="w-full h-12 px-4 text-base border border-gray-300 rounded-md bg-white text-gray-900 placeholder-gray-400 focus:outline-none focus:border-[#C8102E] focus:ring-2 focus:ring-[#C8102E]/20" data-id="element-23" />
        </div>

        <div data-id="element-24">
          <label htmlFor="service" className="block text-base font-medium text-gray-900 mb-2" data-id="element-25">
            What can we help you with?
          </label>
          <select id="service" name="service" required defaultValue="" className="w-full h-12 px-4 pr-10 text-base border border-gray-300 rounded-md bg-white text-gray-900 focus:outline-none focus:border-[#C8102E] focus:ring-2 focus:ring-[#C8102E]/20 appearance-none bg-no-repeat bg-right" style={{
          backgroundImage: "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none' stroke='%23374151' stroke-width='2'%3E%3Cpath d='M6 8l4 4 4-4'/%3E%3C/svg%3E\")",
          backgroundPosition: 'right 0.75rem center'
        }} data-id="element-26">
            <option value="" disabled data-id="element-27">
              Select a service
            </option>
            <option value="Auto Glass" data-id="element-28">Auto Glass</option>
            <option value="Residential Glass" data-id="element-29">Residential Glass</option>
            <option value="Glass Shower Doors" data-id="element-30">Glass Shower Doors</option>
            <option value="Commercial Glass" data-id="element-31">Commercial Glass</option>
          </select>
        </div>

        <button type="submit" className="w-full h-12 sm:h-14 bg-[#C8102E] hover:bg-[#a50d26] active:bg-[#8a0b20] text-white text-lg font-semibold rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#C8102E]" data-id="element-32">
          Check In
        </button>
      </div>
    </form>;
}